module.exports = __webpack_public_path__ + "img/logro.5a48efb2.png";